module.exports = __webpack_public_path__ + "9788f41e/img/copy-icon.408fdb2d.svg";